module.exports = "/assets/data/0133191aeaa82306ec16cea8be54cafe-AB43.data.json";